export default __webpack_public_path__ + "static/Nail5-2c7d2b7fb2cb6afd7f39b93cfb7c2411.png";